module.exports = __webpack_public_path__ + "static/media/bgwave.235b2493.svg";